import type {VirtuosoHandle} from 'react-virtuoso';

import {Block, Divider} from '@travel-frontend/ui-components';
import {Children, useRef, useEffect, useState} from 'react';
import {Virtuoso} from 'react-virtuoso';

export const MenuList = (props: any) => {
  const {children, options, getStyles, selectProps} = props;
  const items = Children.toArray(children);
  const virtuosoRef = useRef<VirtuosoHandle>(null);
  const [isKeyboardNavigation, setIsKeyboardNavigation] = useState(false);

  const focusedOptionIndex = props.focusedOption
    ? options.indexOf(props.focusedOption)
    : -1;

  // Track keyboard vs mouse navigation
  useEffect(() => {
    const handleKeyDown = () => setIsKeyboardNavigation(true);
    const handleMouseMove = () => setIsKeyboardNavigation(false);

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  // Scroll to focused item when it changes, but only for keyboard navigation
  useEffect(() => {
    if (
      focusedOptionIndex >= 0 &&
      virtuosoRef.current &&
      isKeyboardNavigation
    ) {
      virtuosoRef.current.scrollToIndex({
        index: focusedOptionIndex,
        behavior: 'smooth',
        align: 'center',
      });
    }
  }, [focusedOptionIndex, isKeyboardNavigation]);

  const renderItem = (index: number) => (
    <>
      {index > 0 && options[index].label.type === 'groupHeader' ? (
        <Block as={Divider} margin={[0, '16px']} />
      ) : null}
      {items[index]}
      {options[index].label.type === 'reset' && options.length > 1 ? (
        <Block as={Divider} margin={[0, '16px']} />
      ) : null}
    </>
  );

  return (
    <Virtuoso
      ref={virtuosoRef}
      style={{
        ...getStyles('menuList', props),
        height: Math.min(
          400,
          items.length > 5 ? 38 * items.length : 47 * items.length
        ),
      }}
      data={items}
      totalCount={items.length}
      itemContent={renderItem}
      tabIndex={0}
      onKeyDown={selectProps?.onMenuKeyDown}
    />
  );
};
